window.groupTags ??= {};
var cached_product_assets = cached_product_assets || {};
document.addEventListener('swatch:hover', event => {
    const product_id = event.detail.productId;
    const product_card = document.querySelector(`.card-wrapper[product-card-id="${event.detail.productCard}"]`);
    // cache current details
    cached_product_assets['id'] = product_id;
    cached_product_assets['media'] = product_card.querySelector('.card__media .media').innerHTML;
    cached_product_assets['badges'] = product_card.querySelector('.card__badge').innerHTML;
    cached_product_assets['price'] = product_card.querySelector('.product-card-price').innerHTML;
    cached_product_assets['url'] = product_card.querySelector('.info-wrapper .card__heading a').href;
    
    // get replacement data
    const product_data = JSON.parse( document.querySelector(`script[data-product-id="${product_id}"]`).textContent);
    const media = product_card.querySelector(`[data-product-id="${product_id}"].temp-media`).innerHTML;
    const badges = product_card.querySelector(`[data-product-id="${product_id}"].temp-badges`).innerHTML;
    const price = product_card.querySelector(`[data-product-id="${product_id}"].temp-price`).innerHTML;
    const url = `/products/${product_data.handle}`;
    
    // replace product assets
    product_card.querySelector('.card__media .media').innerHTML = media;
    product_card.querySelector('.card__badge').innerHTML = badges;
    product_card.querySelector('.product-card-price').innerHTML = price;
    for(const a of product_card.querySelectorAll('a[href]')) {
      a.setAttribute('href',url);
    }
})
document.addEventListener('swatch:leave', event => {
    // const product_id = event.detail.productId;
    const product_card = document.querySelector(`.card-wrapper[product-card-id="${event.detail.productCard}"]`);
    product_card.querySelector('.card__media .media').innerHTML = cached_product_assets['media'];
    product_card.querySelector('.card__badge').innerHTML = cached_product_assets['badges'];
    product_card.querySelector('.product-card-price').innerHTML = cached_product_assets['price'];
    for(const a of product_card.querySelectorAll('a[href]')) {
      a.setAttribute('href',cached_product_assets['url']);
    }
})
document.addEventListener('swatch:click', event => {
    const product_id = event.detail.productId;
    const product_card = document.querySelector(`.card-wrapper[product-card-id="${event.detail.productCard}"]`);
    const product_data = JSON.parse( document.querySelector(`script[data-product-id="${product_id}"]`).textContent);

    // cache current details
    cached_product_assets['id'] = product_id;
    cached_product_assets['media'] = product_card.querySelector('.card__media .media').innerHTML;
    cached_product_assets['badges'] = product_card.querySelector('.card__badge').innerHTML;
    cached_product_assets['price'] = product_card.querySelector('.product-card-price').innerHTML;
    cached_product_assets['url'] = `/products/${product_data.handle}`;
    for(const a of product_card.querySelectorAll('a[href]')) {
      a.setAttribute('href',cached_product_assets['url']);
    }
})
if (!customElements.get('plp-swatches')) {
  class PlpSwatches extends HTMLElement {
    static get observedAttributes() {
      return ['group-tag', 'product-card'];
    }
  
    connectedCallback() {
      this.loadColorways();
      this.addEventListener('pointerover', this.handlePointerOver);
      this.addEventListener('pointerout', this.handlePointerLeave);
      this.addEventListener('pointerdown', this.handlePointerClick);
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === newValue) return;
  
      if (name === 'group-tag') {
        this.loadColorways();
      }
    }
  
    handlePointerOver = (event) => {
      const link = event.target.closest('a');
      if (!link || !this.contains(link)) return;
      const productId = link.dataset.productId;
      if (!productId) return;
      const productCard = this.getAttribute('product-card');
      document.dispatchEvent(
          new CustomEvent('swatch:hover', {
              detail: {
                  productId,
                  productCard
              }
          })
      );
    };
    
    handlePointerClick = (event) => {
      const link = event.target.closest('a');
      if (!link || !this.contains(link)) return;
      const productId = link.dataset.productId;
      if (!productId) return;
      const productCard = this.getAttribute('product-card');
      document.dispatchEvent(
          new CustomEvent('swatch:click', {
              detail: {
                  productId,
                  productCard
              }
          })
      );
    };
  
    handlePointerLeave = (event) => {
      const link = event.target.closest('a');
      if (!link || !this.contains(link)) return;
  
      const productCard = this.getAttribute('product-card');
      document.dispatchEvent(
          new CustomEvent('swatch:leave', {
              detail: {
                  productCard
              }
          })
      );
    };
  
    async loadColorways() {
      const groupTag = this.getAttribute('group-tag');
      if (!groupTag) return;
      window.groupTags[groupTag] ??= fetch(
          `/collections/all/${encodeURIComponent(groupTag)}?sort_by=price-descending&view=plp-colorways`
      ).then(r => {
          if (!r.ok) throw new Error(`Failed to fetch ${groupTag}`);
          return r.text();
      });
      this.innerHTML = await window.groupTags[groupTag];
      }
  }
  customElements.define('plp-swatches', PlpSwatches);
}